export default {"src":"/_next/static/media/injured-reserve-orange.24926230.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};